
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta } from "/app/pages/auth/login.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as dashboardNa2zxRyeTCZ9YGYMsjbt4iPf4VR60MPXDfl7eaPqKKEMeta } from "/app/pages/admin/dashboard.vue?macro=true";
import { default as indexJbTKBTC_45La21V_gJ1dfnkjN4pCzeJT7KXUYKw0d4FnsMeta } from "/app/pages/admin/iam/index.vue?macro=true";
import { default as usersHFYAuGwJDwXVP4oZ6vLxv7S61XAjRVVLPDWTQIe_J08Meta } from "/app/pages/admin/iam/users.vue?macro=true";
import { default as postess07_45NnO3B3MN8lwyNAd18xFpg0hyZsf5BwTsUFCgm4kMeta } from "/app/pages/admin/iam/postes.vue?macro=true";
import { default as index5lIHIeWweRdrzDBUmym8IjsrehqXmiuORBMI3WjnEKsMeta } from "/app/pages/admin/notes/index.vue?macro=true";
import { default as acces_45refuseSIiYNEIH39QUcQOVUOl2z_DiAmB7w6y0hdR_45F93cMaQMeta } from "/app/pages/auth/acces-refuse.vue?macro=true";
import { default as notificationsRdPBgS1AKhJg0AuZvOV7Agk5Rpiytr86l28OP3hXP3wMeta } from "/app/pages/admin/notifications.vue?macro=true";
import { default as profile9srPbC4b5A1ApdDZ7atE2uNchTO9X7Y4R_RcUfDi0dkMeta } from "/app/pages/admin/pages/profile.vue?macro=true";
import { default as reset_45passwordNpUsiQybcTLi_45Ke3wh24gyldOA9IXhGjC1yM32hGDDMMeta } from "/app/pages/auth/reset-password.vue?macro=true";
import { default as indexfDAghE4OwBu2rH12tW9E84YRx4TKMhLiLvZlvtuFzooMeta } from "/app/pages/admin/planning/index.vue?macro=true";
import { default as define_45passwordUQfLWBzRMd_451AMZvsMH_eDRm6azPSynWs4pTBPmekRIMeta } from "/app/pages/auth/define-password.vue?macro=true";
import { default as forgot_45passwordCSWbKn9J3J_B220JzyKrtw7YYrymJGKEwS0HPhIK87AMeta } from "/app/pages/auth/forgot-password.vue?macro=true";
import { default as login_45encryptedEJN8qO6e4SGhvMiiLVzogqzdFpXFR7Y44E8DYhaq83gMeta } from "/app/pages/auth/login-encrypted.vue?macro=true";
import { default as indexDS6EBTobPQshRnd3NCkAxOpXYF3hgufjZ4XZm_45qNOfUMeta } from "/app/pages/admin/iam/staff/index.vue?macro=true";
import { default as indexO4u4QSWiQCka2a0rVTRK_36wcaoHHhFiDVyQ8e2SlOUMeta } from "/app/pages/admin/maquettes/index.vue?macro=true";
import { default as index14pmQujtkmtXzBQrZhJ0399fDWCIKXz7Obou7EfSzp8Meta } from "/app/pages/admin/parametre/index.vue?macro=true";
import { default as recover_45passwordHQEZKYZHB7rnv__45wkAqI5bKKXLjT0SbFjETED8eOtQYMeta } from "/app/pages/auth/recover-password.vue?macro=true";
import { default as _91id_93KR_45p9mdef54cR5_MRfq2Ws7PxNGMj8A3ncFVAf6pdz8Meta } from "/app/pages/admin/deliberation/[id].vue?macro=true";
import { default as sessionw894FW8l9JfVmvUgSdo9aL2m8LH7pnsOnRxKhbTmo_AMeta } from "/app/pages/admin/parametre/session.vue?macro=true";
import { default as calendarzM6vyC7qiYCnGn0MictrXq_45pWDe_45Mlenu21G0ox7PakMeta } from "/app/pages/admin/planning/calendar.vue?macro=true";
import { default as indexG6fmQZxrDxB9vWUZ4da9ANR6LFYopjK6xqE7VjsbgyoMeta } from "/app/pages/admin/comptabilite/index.vue?macro=true";
import { default as indexqJb_45StxPgQ4n3bSNGkdX3x1IjS_6_45W5PESx1dnvofaIMeta } from "/app/pages/admin/deliberation/index.vue?macro=true";
import { default as google_45calendar_45callbackm_CF3_Z7nGCbj_45JmJBeEDX_igQjnR2bbPt_45Oram3ExIMeta } from "/app/pages/google-calendar-callback.vue?macro=true";
import { default as meuD0MJvZbRYx7TaibVLOuuH0YgsoHbqUqjyjV_lTV9mIMeta } from "/app/pages/admin/academy/students/me.vue?macro=true";
import { default as processusn704fLM4d5scnbGMfCke_7GLAwmep4aerWLs8fdw_45SIMeta } from "/app/pages/admin/parametre/processus.vue?macro=true";
import { default as enseignant7jLMMx_7dOXK2hP7fzVkPKuEBmBdclAG4EX99GsAWucMeta } from "/app/pages/admin/planning/enseignant.vue?macro=true";
import { default as presencesknXV4cjPErIf2g4otwyYVJfkGU5As8yQGuWqoR9A1WoMeta } from "/app/pages/admin/scolarite/presences.vue?macro=true";
import { default as indexBmwWXzbdAjvap_45v1M5sU6R6HqgB_452_tswPDFc2LtImEMeta } from "/app/pages/admin/infrastructure/index.vue?macro=true";
import { default as enseignement5Iulto5y6q6gd6G62rkmdCXYENsQoiOLHC5A7uI_45oD0Meta } from "/app/pages/admin/reports/enseignement.vue?macro=true";
import { default as statistiquesxWtOZCP3vTf4CACj7J4xba3OLOziqpT3TzXkgKmD4E4Meta } from "/app/pages/admin/reports/statistiques.vue?macro=true";
import { default as indexuu4p_45Rjpw3LqFX38hsJ1MAqo2CTeMQHXHaifMEbC05wMeta } from "/app/pages/admin/academy/cloture/index.vue?macro=true";
import { default as index9GityM7Xi5u9PSb5qU4oMaZc7BPoHfS5owgOWqUpmdQMeta } from "/app/pages/admin/academy/session/index.vue?macro=true";
import { default as index9h5bNHRlQc4bZsbxMLYsJnCIjeBf_45U_1zm_UFF3CcgkMeta } from "/app/pages/admin/iam/affectation/index.vue?macro=true";
import { default as processusv2YXPIIzN2FTJE01w6R_FmqyJkJ8dvHGxxzD4xXlNqBosMeta } from "/app/pages/admin/parametre/processusv2.vue?macro=true";
import { default as utilisateuruVA_H_45MnagH0z6o7RjUWSw277h5nIdzsEVYByyJevp0Meta } from "/app/pages/admin/parametre/utilisateur.vue?macro=true";
import { default as request_45password_45resetLR6jBkEoXkNw9Ig9L4U5LeDIVum3W18WV998l1tiJXAMeta } from "/app/pages/auth/request-password-reset.vue?macro=true";
import { default as indexwrRlLgFIiiAQjdJOa_1TXWaUSfuGrbTdNsKXmu8tK9YMeta } from "/app/pages/admin/academy/students/index.vue?macro=true";
import { default as classesO3LSKM3YUuKygDgATxEgLQT0SfSTfdvbANasz__458w2gMeta } from "/app/pages/admin/administration/classes.vue?macro=true";
import { default as bulletinsHKrTCUnXS3_45rm7FTvYScpeGf7D2QPNkS7j3XHFdb50oMeta } from "/app/pages/admin/deliberation/bulletins.vue?macro=true";
import { default as indexqCn1hArG0GHsRZyTfsfesOn6eECjnkz7u1AGudtawzcMeta } from "/app/pages/admin/iam/staff/[slug]/index.vue?macro=true";
import { default as cahiers_45textebxmt7kKdmlT0ODQ7XlFfXISmImVBJchD_45Z06TVeBM9wMeta } from "/app/pages/admin/planning/cahiers-texte.vue?macro=true";
import { default as filieres21s0A_459E_457MobUGzghklT0Vq9YTRIv96N7mJYYyvjWkMeta } from "/app/pages/admin/administration/filieres.vue?macro=true";
import { default as parcoursGowHidwPJBbH__XhPGEJE972QVQSFGy60jVqz8si6LsMeta } from "/app/pages/admin/administration/parcours.vue?macro=true";
import { default as services1yzBa_45eKLH5Aadb9TjSy2GpQtgfP_45iAXFD74NRJkVr0Meta } from "/app/pages/admin/administration/services.vue?macro=true";
import { default as presences_45personnel2pg8BjLPXiqGe9yQ2GPH6cQItfCu_4kkV3OH_453CkRdQMeta } from "/app/pages/admin/iam/presences-personnel.vue?macro=true";
import { default as type_45activites7WOYixSFNcmb558Ti3ws6M5oR_6OgBliQgRXNh_ZQhUMeta } from "/app/pages/admin/planning/type-activites.vue?macro=true";
import { default as google_45calendar_45callback3XxSgluHCNRPhU7ZCUhpAHKphQSm3NM9TEn_7T1WEwUMeta } from "/app/pages/admin/google-calendar-callback.vue?macro=true";
import { default as directionsTQI9rMDR1eI4pGyChatuBtT_45UKvnpTg_45jM9sowuAtqsMeta } from "/app/pages/admin/administration/directions.vue?macro=true";
import { default as formationsYysbT8EhPZmpPbBYRu1Y2SDpMhMdFP9fMxlKAI2nVOUMeta } from "/app/pages/admin/administration/formations.vue?macro=true";
import { default as index5W_YpwyKBaQA34PddKN98m9D9TR_joABh4ITKM_45ysDkMeta } from "/app/pages/admin/comptabilite/etablir/index.vue?macro=true";
import { default as _91id_931rlTL0lb_45DRzMuzXsNhevXg4LuXcpIsGP5wEDjZpLJoMeta } from "/app/pages/admin/comptabilite/factures/[id].vue?macro=true";
import { default as indexBQN2BZodHTe3EepqS5ejSRmhB2zvXI_452Jhbgu63TuSwMeta } from "/app/pages/admin/comptabilite/modeles/index.vue?macro=true";
import { default as enrollmentkRe3nGPycFhdA9l0CfSwSllvNm3nPV9C3p52ccUuIxsMeta } from "/app/pages/admin/academy/students/enrollment.vue?macro=true";
import { default as departementsrKnuTjtscT2Rm_yuRlOarsUJ5u2CgaHg_45d7ybHuCzRwMeta } from "/app/pages/admin/administration/departements.vue?macro=true";
import { default as indexwQyFZei3rUOuqysFNsn3qPlfxu24WpwOvUOaK3XyibUMeta } from "/app/pages/admin/comptabilite/factures/index.vue?macro=true";
import { default as editS_45IYm_455ovWn6qhTJhSrjRCfuq26pT3wmc6iedVjWlWgMeta } from "/app/pages/admin/academy/students/[slug]/edit.vue?macro=true";
import { default as indexFYo8skT7u0XI6mn9Aw9jZ_4RljO8SYEXf17xkpfhaDgMeta } from "/app/pages/admin/iam/affectation/[slug]/index.vue?macro=true";
import { default as indexixZ3yEEGhdBLPiDTKVIZrcYYwd25eufxSV6JF6y3FZMMeta } from "/app/pages/admin/academy/preinscriptions/index.vue?macro=true";
import { default as indexPZ9wWqqG9zP3QUIIfL5m4YGdmHvwl_A224NFSLybf7EMeta } from "/app/pages/admin/academy/students/[slug]/index.vue?macro=true";
import { default as etablissementsxATvlAD5Eg5yx_9YE9D_6mRVx06fI8WlccUgGt3OFAIMeta } from "/app/pages/admin/administration/etablissements.vue?macro=true";
import { default as studentlistv2dt_45PK5vShzGNh_45Iej9Xxyfx4N6IGrJ4_qnHX0l3HMRsMeta } from "/app/pages/admin/academy/students/studentlistv2.vue?macro=true";
import { default as _91id_93ph__mqcwIapQB2uegU44xjPxvthgoxrFtD3YV940oBwMeta } from "/app/pages/admin/deliberation/predeliberation/[id].vue?macro=true";
import { default as indexS9EY7n8yA27Y0PIGQj4XWc94zcBeqZWDFUU5DTqm1tUMeta } from "/app/pages/admin/deliberation/predeliberation/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: loginHOGV2v2PINdTIHc7UC2kEvGCEOmL3_45VnFH_Nuw9GeeMMeta || {},
    component: () => import("/app/pages/auth/login.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {},
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-dashboard",
    path: "/admin/dashboard",
    meta: dashboardNa2zxRyeTCZ9YGYMsjbt4iPf4VR60MPXDfl7eaPqKKEMeta || {},
    component: () => import("/app/pages/admin/dashboard.vue")
  },
  {
    name: "admin-iam",
    path: "/admin/iam",
    meta: indexJbTKBTC_45La21V_gJ1dfnkjN4pCzeJT7KXUYKw0d4FnsMeta || {},
    component: () => import("/app/pages/admin/iam/index.vue")
  },
  {
    name: "admin-iam-users",
    path: "/admin/iam/users",
    meta: usersHFYAuGwJDwXVP4oZ6vLxv7S61XAjRVVLPDWTQIe_J08Meta || {},
    component: () => import("/app/pages/admin/iam/users.vue")
  },
  {
    name: "admin-iam-postes",
    path: "/admin/iam/postes",
    meta: postess07_45NnO3B3MN8lwyNAd18xFpg0hyZsf5BwTsUFCgm4kMeta || {},
    component: () => import("/app/pages/admin/iam/postes.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: index5lIHIeWweRdrzDBUmym8IjsrehqXmiuORBMI3WjnEKsMeta || {},
    component: () => import("/app/pages/admin/notes/index.vue")
  },
  {
    name: "auth-acces-refuse",
    path: "/auth/acces-refuse",
    meta: acces_45refuseSIiYNEIH39QUcQOVUOl2z_DiAmB7w6y0hdR_45F93cMaQMeta || {},
    component: () => import("/app/pages/auth/acces-refuse.vue")
  },
  {
    name: "admin-notifications",
    path: "/admin/notifications",
    meta: notificationsRdPBgS1AKhJg0AuZvOV7Agk5Rpiytr86l28OP3hXP3wMeta || {},
    component: () => import("/app/pages/admin/notifications.vue")
  },
  {
    name: "admin-pages-profile",
    path: "/admin/pages/profile",
    meta: profile9srPbC4b5A1ApdDZ7atE2uNchTO9X7Y4R_RcUfDi0dkMeta || {},
    component: () => import("/app/pages/admin/pages/profile.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45passwordNpUsiQybcTLi_45Ke3wh24gyldOA9IXhGjC1yM32hGDDMMeta || {},
    component: () => import("/app/pages/auth/reset-password.vue")
  },
  {
    name: "admin-planning",
    path: "/admin/planning",
    meta: indexfDAghE4OwBu2rH12tW9E84YRx4TKMhLiLvZlvtuFzooMeta || {},
    component: () => import("/app/pages/admin/planning/index.vue")
  },
  {
    name: "auth-define-password",
    path: "/auth/define-password",
    meta: define_45passwordUQfLWBzRMd_451AMZvsMH_eDRm6azPSynWs4pTBPmekRIMeta || {},
    component: () => import("/app/pages/auth/define-password.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordCSWbKn9J3J_B220JzyKrtw7YYrymJGKEwS0HPhIK87AMeta || {},
    component: () => import("/app/pages/auth/forgot-password.vue")
  },
  {
    name: "auth-login-encrypted",
    path: "/auth/login-encrypted",
    meta: login_45encryptedEJN8qO6e4SGhvMiiLVzogqzdFpXFR7Y44E8DYhaq83gMeta || {},
    component: () => import("/app/pages/auth/login-encrypted.vue")
  },
  {
    name: "admin-iam-staff",
    path: "/admin/iam/staff",
    meta: indexDS6EBTobPQshRnd3NCkAxOpXYF3hgufjZ4XZm_45qNOfUMeta || {},
    component: () => import("/app/pages/admin/iam/staff/index.vue")
  },
  {
    name: "admin-maquettes",
    path: "/admin/maquettes",
    meta: indexO4u4QSWiQCka2a0rVTRK_36wcaoHHhFiDVyQ8e2SlOUMeta || {},
    component: () => import("/app/pages/admin/maquettes/index.vue")
  },
  {
    name: "admin-parametre",
    path: "/admin/parametre",
    meta: index14pmQujtkmtXzBQrZhJ0399fDWCIKXz7Obou7EfSzp8Meta || {},
    component: () => import("/app/pages/admin/parametre/index.vue")
  },
  {
    name: "auth-recover-password",
    path: "/auth/recover-password",
    meta: recover_45passwordHQEZKYZHB7rnv__45wkAqI5bKKXLjT0SbFjETED8eOtQYMeta || {},
    component: () => import("/app/pages/auth/recover-password.vue")
  },
  {
    name: "admin-deliberation-id",
    path: "/admin/deliberation/:id()",
    meta: _91id_93KR_45p9mdef54cR5_MRfq2Ws7PxNGMj8A3ncFVAf6pdz8Meta || {},
    component: () => import("/app/pages/admin/deliberation/[id].vue")
  },
  {
    name: "admin-parametre-session",
    path: "/admin/parametre/session",
    meta: sessionw894FW8l9JfVmvUgSdo9aL2m8LH7pnsOnRxKhbTmo_AMeta || {},
    component: () => import("/app/pages/admin/parametre/session.vue")
  },
  {
    name: "admin-planning-calendar",
    path: "/admin/planning/calendar",
    meta: calendarzM6vyC7qiYCnGn0MictrXq_45pWDe_45Mlenu21G0ox7PakMeta || {},
    component: () => import("/app/pages/admin/planning/calendar.vue")
  },
  {
    name: "admin-comptabilite",
    path: "/admin/comptabilite",
    meta: indexG6fmQZxrDxB9vWUZ4da9ANR6LFYopjK6xqE7VjsbgyoMeta || {},
    component: () => import("/app/pages/admin/comptabilite/index.vue")
  },
  {
    name: "admin-deliberation",
    path: "/admin/deliberation",
    meta: indexqJb_45StxPgQ4n3bSNGkdX3x1IjS_6_45W5PESx1dnvofaIMeta || {},
    component: () => import("/app/pages/admin/deliberation/index.vue")
  },
  {
    name: "google-calendar-callback",
    path: "/google-calendar-callback",
    meta: google_45calendar_45callbackm_CF3_Z7nGCbj_45JmJBeEDX_igQjnR2bbPt_45Oram3ExIMeta || {},
    component: () => import("/app/pages/google-calendar-callback.vue")
  },
  {
    name: "admin-academy-students-me",
    path: "/admin/academy/students/me",
    meta: meuD0MJvZbRYx7TaibVLOuuH0YgsoHbqUqjyjV_lTV9mIMeta || {},
    component: () => import("/app/pages/admin/academy/students/me.vue")
  },
  {
    name: "admin-parametre-processus",
    path: "/admin/parametre/processus",
    meta: processusn704fLM4d5scnbGMfCke_7GLAwmep4aerWLs8fdw_45SIMeta || {},
    component: () => import("/app/pages/admin/parametre/processus.vue")
  },
  {
    name: "admin-planning-enseignant",
    path: "/admin/planning/enseignant",
    meta: enseignant7jLMMx_7dOXK2hP7fzVkPKuEBmBdclAG4EX99GsAWucMeta || {},
    component: () => import("/app/pages/admin/planning/enseignant.vue")
  },
  {
    name: "admin-scolarite-presences",
    path: "/admin/scolarite/presences",
    meta: presencesknXV4cjPErIf2g4otwyYVJfkGU5As8yQGuWqoR9A1WoMeta || {},
    component: () => import("/app/pages/admin/scolarite/presences.vue")
  },
  {
    name: "admin-infrastructure",
    path: "/admin/infrastructure",
    meta: indexBmwWXzbdAjvap_45v1M5sU6R6HqgB_452_tswPDFc2LtImEMeta || {},
    component: () => import("/app/pages/admin/infrastructure/index.vue")
  },
  {
    name: "admin-reports-enseignement",
    path: "/admin/reports/enseignement",
    meta: enseignement5Iulto5y6q6gd6G62rkmdCXYENsQoiOLHC5A7uI_45oD0Meta || {},
    component: () => import("/app/pages/admin/reports/enseignement.vue")
  },
  {
    name: "admin-reports-statistiques",
    path: "/admin/reports/statistiques",
    meta: statistiquesxWtOZCP3vTf4CACj7J4xba3OLOziqpT3TzXkgKmD4E4Meta || {},
    component: () => import("/app/pages/admin/reports/statistiques.vue")
  },
  {
    name: "admin-academy-cloture",
    path: "/admin/academy/cloture",
    meta: indexuu4p_45Rjpw3LqFX38hsJ1MAqo2CTeMQHXHaifMEbC05wMeta || {},
    component: () => import("/app/pages/admin/academy/cloture/index.vue")
  },
  {
    name: "admin-academy-session",
    path: "/admin/academy/session",
    meta: index9GityM7Xi5u9PSb5qU4oMaZc7BPoHfS5owgOWqUpmdQMeta || {},
    component: () => import("/app/pages/admin/academy/session/index.vue")
  },
  {
    name: "admin-iam-affectation",
    path: "/admin/iam/affectation",
    meta: index9h5bNHRlQc4bZsbxMLYsJnCIjeBf_45U_1zm_UFF3CcgkMeta || {},
    component: () => import("/app/pages/admin/iam/affectation/index.vue")
  },
  {
    name: "admin-parametre-processusv2",
    path: "/admin/parametre/processusv2",
    meta: processusv2YXPIIzN2FTJE01w6R_FmqyJkJ8dvHGxxzD4xXlNqBosMeta || {},
    component: () => import("/app/pages/admin/parametre/processusv2.vue")
  },
  {
    name: "admin-parametre-utilisateur",
    path: "/admin/parametre/utilisateur",
    meta: utilisateuruVA_H_45MnagH0z6o7RjUWSw277h5nIdzsEVYByyJevp0Meta || {},
    component: () => import("/app/pages/admin/parametre/utilisateur.vue")
  },
  {
    name: "auth-request-password-reset",
    path: "/auth/request-password-reset",
    meta: request_45password_45resetLR6jBkEoXkNw9Ig9L4U5LeDIVum3W18WV998l1tiJXAMeta || {},
    component: () => import("/app/pages/auth/request-password-reset.vue")
  },
  {
    name: "admin-academy-students",
    path: "/admin/academy/students",
    meta: indexwrRlLgFIiiAQjdJOa_1TXWaUSfuGrbTdNsKXmu8tK9YMeta || {},
    component: () => import("/app/pages/admin/academy/students/index.vue")
  },
  {
    name: "admin-administration-classes",
    path: "/admin/administration/classes",
    meta: classesO3LSKM3YUuKygDgATxEgLQT0SfSTfdvbANasz__458w2gMeta || {},
    component: () => import("/app/pages/admin/administration/classes.vue")
  },
  {
    name: "admin-deliberation-bulletins",
    path: "/admin/deliberation/bulletins",
    meta: bulletinsHKrTCUnXS3_45rm7FTvYScpeGf7D2QPNkS7j3XHFdb50oMeta || {},
    component: () => import("/app/pages/admin/deliberation/bulletins.vue")
  },
  {
    name: "admin-iam-staff-slug",
    path: "/admin/iam/staff/:slug()",
    meta: indexqCn1hArG0GHsRZyTfsfesOn6eECjnkz7u1AGudtawzcMeta || {},
    component: () => import("/app/pages/admin/iam/staff/[slug]/index.vue")
  },
  {
    name: "admin-planning-cahiers-texte",
    path: "/admin/planning/cahiers-texte",
    meta: cahiers_45textebxmt7kKdmlT0ODQ7XlFfXISmImVBJchD_45Z06TVeBM9wMeta || {},
    component: () => import("/app/pages/admin/planning/cahiers-texte.vue")
  },
  {
    name: "admin-administration-filieres",
    path: "/admin/administration/filieres",
    meta: filieres21s0A_459E_457MobUGzghklT0Vq9YTRIv96N7mJYYyvjWkMeta || {},
    component: () => import("/app/pages/admin/administration/filieres.vue")
  },
  {
    name: "admin-administration-parcours",
    path: "/admin/administration/parcours",
    meta: parcoursGowHidwPJBbH__XhPGEJE972QVQSFGy60jVqz8si6LsMeta || {},
    component: () => import("/app/pages/admin/administration/parcours.vue")
  },
  {
    name: "admin-administration-services",
    path: "/admin/administration/services",
    meta: services1yzBa_45eKLH5Aadb9TjSy2GpQtgfP_45iAXFD74NRJkVr0Meta || {},
    component: () => import("/app/pages/admin/administration/services.vue")
  },
  {
    name: "admin-iam-presences-personnel",
    path: "/admin/iam/presences-personnel",
    meta: presences_45personnel2pg8BjLPXiqGe9yQ2GPH6cQItfCu_4kkV3OH_453CkRdQMeta || {},
    component: () => import("/app/pages/admin/iam/presences-personnel.vue")
  },
  {
    name: "admin-planning-type-activites",
    path: "/admin/planning/type-activites",
    meta: type_45activites7WOYixSFNcmb558Ti3ws6M5oR_6OgBliQgRXNh_ZQhUMeta || {},
    component: () => import("/app/pages/admin/planning/type-activites.vue")
  },
  {
    name: "admin-google-calendar-callback",
    path: "/admin/google-calendar-callback",
    meta: google_45calendar_45callback3XxSgluHCNRPhU7ZCUhpAHKphQSm3NM9TEn_7T1WEwUMeta || {},
    component: () => import("/app/pages/admin/google-calendar-callback.vue")
  },
  {
    name: "admin-administration-directions",
    path: "/admin/administration/directions",
    meta: directionsTQI9rMDR1eI4pGyChatuBtT_45UKvnpTg_45jM9sowuAtqsMeta || {},
    component: () => import("/app/pages/admin/administration/directions.vue")
  },
  {
    name: "admin-administration-formations",
    path: "/admin/administration/formations",
    meta: formationsYysbT8EhPZmpPbBYRu1Y2SDpMhMdFP9fMxlKAI2nVOUMeta || {},
    component: () => import("/app/pages/admin/administration/formations.vue")
  },
  {
    name: "admin-comptabilite-etablir",
    path: "/admin/comptabilite/etablir",
    meta: index5W_YpwyKBaQA34PddKN98m9D9TR_joABh4ITKM_45ysDkMeta || {},
    component: () => import("/app/pages/admin/comptabilite/etablir/index.vue")
  },
  {
    name: "admin-comptabilite-factures-id",
    path: "/admin/comptabilite/factures/:id()",
    meta: _91id_931rlTL0lb_45DRzMuzXsNhevXg4LuXcpIsGP5wEDjZpLJoMeta || {},
    component: () => import("/app/pages/admin/comptabilite/factures/[id].vue")
  },
  {
    name: "admin-comptabilite-modeles",
    path: "/admin/comptabilite/modeles",
    meta: indexBQN2BZodHTe3EepqS5ejSRmhB2zvXI_452Jhbgu63TuSwMeta || {},
    component: () => import("/app/pages/admin/comptabilite/modeles/index.vue")
  },
  {
    name: "admin-academy-students-enrollment",
    path: "/admin/academy/students/enrollment",
    meta: enrollmentkRe3nGPycFhdA9l0CfSwSllvNm3nPV9C3p52ccUuIxsMeta || {},
    component: () => import("/app/pages/admin/academy/students/enrollment.vue")
  },
  {
    name: "admin-administration-departements",
    path: "/admin/administration/departements",
    meta: departementsrKnuTjtscT2Rm_yuRlOarsUJ5u2CgaHg_45d7ybHuCzRwMeta || {},
    component: () => import("/app/pages/admin/administration/departements.vue")
  },
  {
    name: "admin-comptabilite-factures",
    path: "/admin/comptabilite/factures",
    meta: indexwQyFZei3rUOuqysFNsn3qPlfxu24WpwOvUOaK3XyibUMeta || {},
    component: () => import("/app/pages/admin/comptabilite/factures/index.vue")
  },
  {
    name: "admin-academy-students-slug-edit",
    path: "/admin/academy/students/:slug()/edit",
    meta: editS_45IYm_455ovWn6qhTJhSrjRCfuq26pT3wmc6iedVjWlWgMeta || {},
    component: () => import("/app/pages/admin/academy/students/[slug]/edit.vue")
  },
  {
    name: "admin-iam-affectation-slug",
    path: "/admin/iam/affectation/:slug()",
    meta: indexFYo8skT7u0XI6mn9Aw9jZ_4RljO8SYEXf17xkpfhaDgMeta || {},
    component: () => import("/app/pages/admin/iam/affectation/[slug]/index.vue")
  },
  {
    name: "admin-academy-preinscriptions",
    path: "/admin/academy/preinscriptions",
    meta: indexixZ3yEEGhdBLPiDTKVIZrcYYwd25eufxSV6JF6y3FZMMeta || {},
    component: () => import("/app/pages/admin/academy/preinscriptions/index.vue")
  },
  {
    name: "admin-academy-students-slug",
    path: "/admin/academy/students/:slug()",
    meta: indexPZ9wWqqG9zP3QUIIfL5m4YGdmHvwl_A224NFSLybf7EMeta || {},
    component: () => import("/app/pages/admin/academy/students/[slug]/index.vue")
  },
  {
    name: "admin-administration-etablissements",
    path: "/admin/administration/etablissements",
    meta: etablissementsxATvlAD5Eg5yx_9YE9D_6mRVx06fI8WlccUgGt3OFAIMeta || {},
    component: () => import("/app/pages/admin/administration/etablissements.vue")
  },
  {
    name: "admin-academy-students-studentlistv2",
    path: "/admin/academy/students/studentlistv2",
    meta: studentlistv2dt_45PK5vShzGNh_45Iej9Xxyfx4N6IGrJ4_qnHX0l3HMRsMeta || {},
    component: () => import("/app/pages/admin/academy/students/studentlistv2.vue")
  },
  {
    name: "admin-deliberation-predeliberation-id",
    path: "/admin/deliberation/predeliberation/:id()",
    meta: _91id_93ph__mqcwIapQB2uegU44xjPxvthgoxrFtD3YV940oBwMeta || {},
    component: () => import("/app/pages/admin/deliberation/predeliberation/[id].vue")
  },
  {
    name: "admin-deliberation-predeliberation",
    path: "/admin/deliberation/predeliberation",
    meta: indexS9EY7n8yA27Y0PIGQj4XWc94zcBeqZWDFUU5DTqm1tUMeta || {},
    component: () => import("/app/pages/admin/deliberation/predeliberation/index.vue")
  }
]